import { CustomEditor } from "../duck";
import { onKeyDown } from "./duck";

const withEventListeners = <T extends CustomEditor>(editor: T): T => {
  editor.onKeyDown = onKeyDown(editor);

  return editor;
};

export default withEventListeners;
